package kz.dentalcrm.app.screens.services.detail.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

sealed interface EditServiceViewEvent : ViewEvent {

    data class EditService(
        val id: Int,
        val naming: String,
        val description: String,
        val duration: String,
        val price: String
    ) : EditServiceViewEvent

    data class DeleteService(val id: Int) : EditServiceViewEvent

    data class CategorySelected(
        val category: ServiceCategory
    ) : EditServiceViewEvent

    data object Reset : EditServiceViewEvent
}